
const sales_data_sent = [
    'closed_at',
    'sale_data_sent.0.created_at', 
    'name', 
    'final_amount', 
    'sale_data_sent.0.entity', 
    'sale_data_sent.0.status', 
    'sale_data_sent.0.retry',
    'sale_data_sent.0.reason_failed',
    'sale_data_sent.0.id',
    'sale_data_sent.0.uuid',
    'id',
    'sale_data_sent.0.updated_at'
];

export const columnsOrder = {
    sales_data_sent
};